import React from "react";
import {
  SEQ_STATUS,
  formatSequentialIls,
} from "../../../utils/payment/sequentialMultiCardPayment";

const STATUS_COPY = {
  [SEQ_STATUS.PAID]: "שולם",
  [SEQ_STATUS.ACTIVE]: "בתהליך",
  [SEQ_STATUS.PROCESSING]: "בתהליך",
  [SEQ_STATUS.PENDING]: "ממתין",
  [SEQ_STATUS.FAILED]: "לא הושלם",
};

const STATUS_GLYPH = {
  [SEQ_STATUS.PAID]: "✓",
  [SEQ_STATUS.ACTIVE]: "●",
  [SEQ_STATUS.PROCESSING]: "●",
  [SEQ_STATUS.PENDING]: "○",
  [SEQ_STATUS.FAILED]: "!",
};

export default function SequentialPaymentTracker({ steps = [] }) {
  if (!Array.isArray(steps) || steps.length <= 1) return null;

  return (
    <section className="seq-tracker" dir="rtl" aria-label="סטטוס התשלומים">
      <h3 className="seq-tracker__title">סטטוס התשלומים</h3>
      <ul className="seq-tracker__list">
        {steps.map((step) => {
          const amount =
            step.status === SEQ_STATUS.PAID && step.chargedAmount > 0
              ? step.chargedAmount
              : step.plannedAmount;
          return (
            <li
              key={`seq-track-${step.index}`}
              className={`seq-tracker__row seq-tracker__row--${String(step.status).toLowerCase()}`}
            >
              <div className="seq-tracker__main">
                <span className="seq-tracker__name">תשלום {step.index + 1}</span>
                <span className="seq-tracker__amount">{formatSequentialIls(amount)}</span>
              </div>
              <span className="seq-tracker__status">
                <span aria-hidden>{STATUS_GLYPH[step.status] || "○"}</span>
                {STATUS_COPY[step.status] || step.status}
                {step.status === SEQ_STATUS.PAID && step.last4
                  ? ` · •••• ${step.last4}`
                  : null}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
